import { fromPromise } from "xstate";
import type {
  CheckoutGateway,
  ResolveTargetInput,
  ResolvedCheckoutTarget,
} from "./contracts";
import { runCheckoutActor } from "./timeout";

export interface TargetActorInput extends ResolveTargetInput {
  gateway: CheckoutGateway;
}

export const resolveTargetActor = fromPromise<
  ResolvedCheckoutTarget,
  TargetActorInput
>(async ({ input, signal }) =>
  runCheckoutActor(signal, (derivedSignal) =>
    input.gateway.resolveTarget({
      runtime: input.runtime,
      requestedTargetKey: input.requestedTargetKey,
      signal: derivedSignal,
    }),
  ),
);
